import { render, staticRenderFns } from "./company_register.vue?vue&type=template&id=778bd6e8&scoped=true"
import script from "./company_register.vue?vue&type=script&lang=js"
export * from "./company_register.vue?vue&type=script&lang=js"
import style0 from "./company_register.vue?vue&type=style&index=0&id=778bd6e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778bd6e8",
  null
  
)

export default component.exports